// extracted by mini-css-extract-plugin
export default {"active-topic-class":"styles-module__active-topic-class___X4nTE","active-topic-class-tags":"styles-module__active-topic-class-tags___jMHiJ"};